/* eslint-disable */
import {
  Box,
  Button,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  TextField,
  Tooltip,
  Typography,
  Autocomplete,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  FormControl,
  Fab
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useEffect, useState } from "react";
import Message from "../../../utils/Message";
import {
  getPersonasFisicas,
} from "../../../services/PersonaFisicaService";
import { useNavigate } from "react-router-dom";
import "../../../core/styles/busqueda.css";
import { Add, Clear, DoNotDisturbOn, Edit } from "@mui/icons-material";
import { getTiposDocumento } from "../../../services/ParametrosService";

const initialSearchData = {
  numeroDocumento: "",
  fecha_nacimiento: "",
  fecha_fallecimiento: "",
  cuil: "",
  cuit: "",
  email: "",
  estadoCivil: "",
  profesiones: "",
  telefono: "",
  domicilio: "",
  estado_civil: "",
  fecha_actualizacion: "",
  argentino: "Si",
  apellido: "",
  nombre: "",
  idTipoDocumento: "",
};

const nameItemsText = "Personas Físicas";
//
// #############################################################################  
//
const PersonaFisicaTable = () => {
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState(initialSearchData);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [personas, setPersonas] = useState([]);
  const [PersonaSelected, setPersonaSelected] = useState([]);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [_idPersona, set_idPersona] = useState(null);
  const [documentos, setDocumentos] = useState([]);
  const [valueAutoCompleteTipoDocumento, setValueAutoCompleteTipoDocumento]
    = useState
      ({
        id: "",
        descripcion: ""
      })
  const [
    inputValueAutoCompleteTipoDocumento,
    setInputValueAutoCompleteTipoDocumento]
    = useState("");

  const tableColumns = [
    {
      name: "id",
      label: "ID",
      options: {
        display: "excluded",
      },
    },
    {
      name: "cuil",
      label: "N° de Identificación",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
          },
        }),
        customBodyRender: (value, tableMeta) => {
          const rowIndex = tableMeta.rowIndex;
          const persona = personas[rowIndex];

          if (!persona) return "";

          if (persona.extranjero === false) {
            return persona.cuil || "";
          } else {
            // Devuelve el número del primer documento si existe
            const doc = persona.documentos?.[0];
            return doc?.numero || "";
          }
        }
      },
    },
    {
      name: "apellido",
      label: "Apellido",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: 'left'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'left',
          },
        }),
        customBodyRender: (value) => {
          // pasa el valor a mayusculas c
          return value.toUpperCase();
        }
      },
    },
    {
      name: "nombre",
      label: "Nombres",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: 'left'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'left',
          },
        }),
        customBodyRender: (value) => {
          // pasa el valor a mayusculas
          return value.toUpperCase();
        }
      },
    },
    {
      name: "email",
      label: "Correo Electrónico",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: 'left'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'left',
          },
        })
      },
    },
    {
      name: "fecha_creacion",
      label: "Fecha de Creación",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
          },
        }),
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let _val = ""
          let _fecha = new Date(personas[dataIndex].fecha_creacion)
          let _dia = _fecha.getDate().toString().padStart(2, '0')
          let _mes = (_fecha.getMonth() + 1).toString().padStart(2, '0')
          let _anio = _fecha.getFullYear()
          let _hora = _fecha.getHours().toString().padStart(2, '0')
          let _minutos = _fecha.getMinutes().toString().padStart(2, '0')
          let _segundos = _fecha.getSeconds().toString().padStart(2, '0')
          _val = _dia + '-' + _mes + '-' + _anio + ' ' + _hora + ':' + _minutos + ':' + _segundos

          return _val;
        },
      },
    },

    {
      name: "actions",
      label: "Acciones",
      options: {
        filter: false,
        sort: false,
        empty: true,
        setCellProps: () => ({
          style: {
            textAlign: 'left'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'left',
          },
        }),
        customBodyRenderLite: (dataIndex, rowIndex) => (
          <>

            <Tooltip title="Ver Persona">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => obtienePersona(dataIndex, "view")}
              >
                <RemoveRedEyeOutlinedIcon />
              </IconButton>

            </Tooltip>
            {/* <Tooltip title="Editar Persona">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => editaPersona(dataIndex, "edit")}
              >
                <Edit />
              </IconButton>
            </Tooltip> */}
          </>
        ),
      },
    },
  ];

  const tableOptions = {
    download: false,
    filter: false,
    print: false,
    search: false,
    viewColumns: false,
    elevation: 5,
    // Controls the visibility of the Select Toolbar
    selectToolbarPlacement: "none",
    // Show/hide the select all/deselect all checkbox header for selectable rows
    selectableRowsHeader: false,
    // Hides the checkboxes that appear when selectableRows is set to "multiple" or "single"
    selectableRowsHideCheckboxes: false,
    // Indicates if rows can be selected. Options are "multiple", "single", "none"
    selectableRows: "none",

    // Callback function that triggers when row(s) are selected/deselected
    onRowSelectionChange: (
      currentRowsSelected,
      allRowsSelected,
      rowsSelected
    ) => {
      seleccionarPersona(currentRowsSelected, allRowsSelected, rowsSelected);
    },
    // User provided array of numbers (dataIndexes) which indicates the selected rows
    rowsSelected: PersonaSelected,

    rowsPerPageOptions: [10, 20, 30],
    serverSide: true,
    count: totalRowsCount,
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
    },
    onChangePage: (currentPage) => {
      setCurrentPage(currentPage);
    },
    textLabels: {
      body: {
        noMatch: "No se encontraron registros",
      },
      pagination: {
        next: "Próxima",
        previous: "Previa",
        rowsPerPage: "Filas:",
        displayRows: "de",
      },
    },
  };

  //
  // ################################################################################
  //
  const seleccionarPersona = (currentRowsSelected, allRowsSelected, rowsSelected
  ) => {
    setPersonaSelected(rowsSelected);
  };

  //
  // ################################################################################
  // cuando cambia la pagina actual o la cantidad de filas por pagina
  //
  useEffect(() => {
    load();
    loadTiposDocumento();
  }, [currentPage, rowsPerPage]);

  //
  // ################################################################################
  //
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchData(prevState => ({
      ...prevState,
      [name]: value,
    }));
    console.log('searchData updated:', { ...searchData, [name]: value });
  };



  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setSearchData(prevState => ({
      ...prevState,
      [name]: value,
    }));
    console.log('Radio changed:', { ...searchData, [name]: value });
  };



  //
  // ################################################################################
  //
  const handleChangeFechaCreacionDesde = (fecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionDesde: fecha,
    });
  };

  //
  // ################################################################################
  //
  const handleChangeFechaCreacionHasta = (fecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionHasta: fecha,
    });
  };

  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setIsDoingSomething(true);
    setSearchData(initialSearchData);
    setValueAutoCompleteTipoDocumento({
      id: "",
      descripcion: ""
    });
    setTotalRowsCount(0);
    setPersonas([]);
    setPersonaSelected([]);
    setIsDoingSomething(false);
  };

  const handleNuevaPersonaFisica = () => {
    navigate("/personas/persona-fisica/new");
  }

  //
  // ################################################################################
  //
  const handleBuscar = () => {
    load();
  };

  //
  // ################################################################################
  // Funcion de busqueda .. 


  const load = async () => {
    let _params = {
      argentino: searchData.argentino,
      fechaCreacionDesde: searchData.fechaCreacionDesde,
      fechaCreacionHasta: searchData.fechaCreacionHasta,
      estadoActual: searchData.estadoActual,
      nombre: searchData.nombre,
      apellido: searchData.apellido,
      cuil: searchData.cuil,
      cuit: searchData.cuit,
      matricula: searchData.matricula,
      numeroDocumento: searchData.numeroDocumento,
      sexoRegistradoNacimiento: searchData.sexoRegistradoNacimiento,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getPersonasFisicas(_params);
    setIsDoingSomething(false);
    if (response.ok) {
      let _personas = response.data.data;
      setTotalRowsCount(response.data.count);
      setPersonas(_personas);


    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };

  //
  // ###############################################################################
  //

  const loadTiposDocumento = async () => {
    const response = await getTiposDocumento();
    if (response.ok) {
      let _response = response.data[0].data;
      _response.forEach((item) => {
        item.descripcion = item.descripcion.toUpperCase();
      });

      setDocumentos(_response);

    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }


  //
  // ###############################################################################
  //
  const obtienePersona = (dataIndex, parAction) => {
    let _id = personas[dataIndex].id;
    // let _url = "/personas/persona-fisica/" + _id + "/" + parAction;
    // window.open(_url, "_blank");
    navigate("/personas/persona-fisica/" + _id + "/" + parAction);

  };

  //
  // ###############################################################################
  //
  const nuevaPersonaFisica = () => {
    navigate("/personas/persona-fisica/new");

  };

  //
  // ################################################################################
  //
  const editaPersona = (dataIndex, parAction) => {
    let _id = personas[dataIndex].id;
    navigate("/personas/persona-fisica/" + _id + "/" + parAction);

  }
  //
  // ################################################################################
  // habilito para que al precionar la tecla enter se ejecute la busqueda

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      console.log('ejecutando keydown');

      handleBuscar();
    }
  };


  return (
    <>

      <Paper elevation={0} sx={{ p: 1, m: 1, maxWidth: "100%" }}>

        <Paper elevation={3} sx={{ mb: 1 }}>
          <Box p={2}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center" sx={{ mb: 2, mt: 2 }}>
                  <Typography variant="h4" display="block" gutterBottom>
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={6} lg={6}>
                <FormControl component="fieldset">
                  <Box display="flex" alignItems="center" sx={{ '& .MuiFormControlLabel-root': { pl: 7 } }}>
                    <FormLabel component="legend" sx={{ ml: 2 }}>Argentino/a</FormLabel>
                    <RadioGroup
                      aria-label="argentino"
                      name="argentino"
                      value={searchData.argentino}
                      onChange={handleRadioChange}
                      row
                    >
                      <FormControlLabel value="Si" control={<Radio />} label="Si" />
                      <FormControlLabel value="No" control={<Radio />} label="No" />
                    </RadioGroup>
                  </Box>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={12} lg={2}> </Grid>
              <Grid item xs={12} md={12} lg={2}> </Grid><Grid item xs={12} md={12} lg={2}> </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="apellido"
                  label="Apellido"
                  variant="outlined"
                  size="small"
                  name="apellido"
                  value={searchData.apellido}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="nombre"
                  label="Nombre"
                  variant="outlined"
                  size="small"
                  name="nombre"
                  value={searchData.nombre}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />

              </Grid>


              <Grid item xs={12} sm={6} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="cuil"
                  label="Cuil"
                  variant="outlined"
                  size="small"
                  name="cuil"
                  value={searchData.cuil}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />

              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="cuit"
                  label="Cuit"
                  variant="outlined"
                  size="small"
                  name="cuit"
                  value={searchData.cuit}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>


              <Grid item xs={12} md={12} lg={2}> </Grid><Grid item xs={12} md={12} lg={2}> </Grid>


              <Grid item xs={12} md={12} lg={3}>
                <Autocomplete
                  id="id-tipo-documento"
                  size="small"
                  value={valueAutoCompleteTipoDocumento && valueAutoCompleteTipoDocumento.id ? valueAutoCompleteTipoDocumento : null}
                  onChange={(event, newValue) => {
                    setValueAutoCompleteTipoDocumento(newValue);
                    setSearchData({
                      ...searchData,
                      idTipoDocumento: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueAutoCompleteTipoDocumento}
                  onInputChange={(event, newInputValue) => {
                    setInputValueAutoCompleteTipoDocumento(newInputValue);
                  }}
                  options={documentos}
                  getOptionLabel={(option) => option.descripcion}
                  renderInput={(params) => (
                    <TextField {...params} label="Tipo de Documento" />
                  )}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="numeroDocumento"
                  label="N° de Documento"
                  variant="outlined"
                  size="small"
                  name="numeroDocumento"
                  value={searchData.numeroDocumento}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={12}></Grid>
              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="Crear Nueva Persona">
                    <Button
                      fullWidth
                      sx={{ backgroundColor: "DarkGreen", color: "white" }}
                      className="btn-add"
                      variant="contained"
                      size="small"
                      onClick={handleNuevaPersonaFisica}
                      // onClick={nuevoAjuste}
                      startIcon={<Add />}
                    >
                      Nueva
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="Limpiar filtros">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="Buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

            </Grid>

          </Box>
        </Paper >

        {isDoingSomething && <LinearProgress />}

        <MUIDataTable
          title={"Listado de Personas Físicas"}
          data={personas}
          columns={tableColumns}
          options={tableOptions}
        />

      </Paper >


      {/* >>>> Messages */}

      {
        showMessage && (
          <Message
            showMessage={showMessage}
            setShowMessage={setShowMessage}
            message={message}
          />
        )
      }
    </>
  );
};

export default PersonaFisicaTable;
